import Classes from './Classes';

const ClassesPage = ({ isAdmin, viewAs }) => {
  // if (!isAdmin) {
  //   return (
  //     <div>
  //       <h1>Access denied</h1>
  //       <p>You do not have permission to access this page.</p>
  //     </div>
  //   );
  // }

  return <Classes isAdmin={isAdmin} viewAs={viewAs} />;
};

export default ClassesPage;
